"use strict";

module.exports = require("./is-implemented")() ? globalThis : require("./implementation");



//////////////////
// WEBPACK FOOTER
// ./~/ext/global-this/index.js
// module id = 78
// module chunks = 0